import './monkeyPatches';
import 'styles/global.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { useEditorStore } from 'modules/editor/store';
import { ReactGA } from 'utils/googleAnalytics';
import config from 'config';
import App from './App';

if (config.USE_ANALYTICS) {
  ReactGA.initialize(config.API_KEY_GA, {
    gaOptions: { cookieFlags: 'secure;samesite=none' },
  });
  ReactGA.set({ anonymizeIp: true });
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
}

if (config.USE_SENTRY) {
  Sentry.init({
    dsn: 'https://6302f18d1cbfbef6431c8a733ecd6abc@o21767.ingest.sentry.io/4506819342565376',
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    integrations: [
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllText: false,
        maskAllInputs: false,
      }),
      Sentry.replayCanvasIntegration(),
    ],
    release: config.BUILD,
    environment: config.ENV,
    normalizeDepth: 10, // contexts depth
    beforeSend: (event) => {
      event.contexts = {
        ...event.contexts,
        editorState: {
          editorState: JSON.parse(JSON.stringify(useEditorStore.getState())),
        },
      };

      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// handles cases when user has older bundles/code in browser, but deploy has removed them
// @see: https://vite.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});
